export const pagesTestSuitesEn = {
  detail: {
    breadcrumb: {
      home: 'Home',
      testSuites: 'Test Suites',
    },
    documents: {
      columns: {
        createdAt: 'Created',
        createdBy: 'Created by',
        name: 'Name',
        status: 'Status',
        type: 'Type',
        updatedAt: 'Updated',
        updatedBy: 'Updated by',
      },
      filterPlaceholder: 'Filter Key, Summary...',
      noResults: 'No documents matched the current filter.',
      tabs: {
        all: 'All',
        forExternal: 'For External',
        forInternal: 'For Internal',
      },
    },
    header: {
      actions: {
        edit: 'Edit',
        releaseDecision: 'Release Decision',
      },
      labels: {
        createdAt: 'Created on {{date}}',
        release: 'Release',
        testPlan: 'Test Plan',
      },
      ownerNotSet: 'Not set',
    },
    options: {
      releaseTestDocumentStatus: {
        ARCHIVED: 'Archived',
        DONE: 'Done',
        DRAFT: 'Draft',
        IN_PROGRESS: 'In Progress',
        IN_REVIEW: 'In Review',
      },
      releaseTestDocumentType: {
        FOR_EXTERNAL: 'External',
        FOR_INTERNAL: 'Internal',
      },
      testReviewResult: {
        CONDITIONAL_OK: 'Conditional Approval',
        NG: 'NG',
        OK: 'Approved',
        UNTOUCHED: 'Pending',
      },
    },
    overview: {
      affectedCustomers: {
        high: 'High Revenue Impact',
        low: 'Low Revenue Impact',
        mid: 'Medium Revenue Impact',
        title: 'Estimated Affected Customers',
      },
      affectedUsers: {
        others: '{{count}} more',
        title: 'Estimated Affected Users',
      },
      blockingIssues: {
        title: 'Blocking Issues',
        unresolvedThreshold: 'Unresolved {{hours}}h+',
      },
      fixModules: {
        function: 'Function',
        module: 'Module',
        subModule: 'Sub Module',
        title: 'Product Scope',
      },
      issueSeverity: {
        critical: 'Critical',
        enhancement: 'Enhancement',
        major: 'Major',
        minor: 'Minor',
        normal: 'Normal',
        title: 'Issues',
      },
      progressDelayRate: {
        dayOverDay: '{{delta}}% vs yesterday',
        title: 'Progress Delay Rate',
      },
      releaseConcernIssues: {
        title: 'Release-Risk Issues',
        unresolvedThreshold: 'Unresolved {{hours}}h+',
      },
      testProgress: {
        caseCompleted: '{{completed}} / {{total}} cases completed',
        title: 'Test Progress',
      },
      trendChart: {
        day: 'Day',
        month: 'Month',
        remainingTests: 'Remaining Tests',
        title: 'Test Progress',
        week: 'Week',
      },
      units: {
        company: 'companies',
        count: 'issues',
        percent: '%',
        user: 'users',
      },
    },
    pageTitle: '{{name}}',
    releaseLevel: {
      HOTFIX: 'Hotfix',
      MAJOR: 'Major',
      MINOR: 'Minor',
      PATCH: 'Patch',
      REVISION: 'Revision',
    },
    tabs: {
      document: 'Documents',
      history: 'History',
      issue: 'Issues',
      overview: 'Overview',
      targetFunctions: 'Target Functions',
      testPlan: 'Test Plan',
      testReview: 'Test Review',
      testSet: 'Test Set',
    },
    targetFunctions: {
      noResults: 'No target functions are scoped for this test suite.',
      table: {
        headers: {
          kind: 'Type',
          name: 'Name',
          publishStatus: 'Status',
        },
        kind: {
          FUNCTION: 'Function',
          MODULE: 'Module',
          PRODUCT: 'Product',
          SUB_MODULE: 'Sub Module',
        },
      },
    },
    testPlan: {
      basicInfo: {
        fields: {
          owner: 'Owner',
          relatedRelease: 'Related Release',
          releaseLevel: 'Release Level',
          targetProduct: 'Target Product',
          targetVersion: 'Target Version',
          testPlanId: 'Test Plan ID',
          testPlanName: 'Test Plan Name',
        },
        sectionTitle: 'Basic Info',
      },
      sidebar: {
        basicInfo: 'Basic Info',
        testEnvironment: 'Test Environment & Tools',
        testPolicy: 'Test Policy',
        testRisk: 'Test Risks',
        testSchedule: 'Test Schedule',
        testScope: 'Test Scope',
        testTeam: 'Test Team',
      },
      testEnvironment: {
        fields: {
          environmentConstraints: 'Environment Constraints',
          environmentIds: 'Test Environments',
          environmentSpec: 'Test Environment Spec',
          testData: 'Test Data',
          testingToolIds: 'Tools Used',
        },
        sectionTitle: 'Test Environment & Tools',
      },
      testPolicy: {
        fields: {
          automationPolicy: 'Automation Policy',
          regressionTestingPolicy: 'Regression Testing Policy',
          testingPolicy: 'Test Policy',
        },
        sectionTitle: 'Test Policy',
      },
      testRisk: {
        fields: {
          prioritizationCriteria: 'Prioritization Criteria',
          riskCountermeasures: 'Risk Countermeasures',
          testRisks: 'Test Risks',
        },
        sectionTitle: 'Test Risks',
      },
      testSchedule: {
        fields: {
          entryCriteria: 'Entry Criteria',
          exitCriteria: 'Exit Criteria',
          milestones: 'Milestones',
          testSchedule: 'Test Schedule',
        },
        sectionTitle: 'Test Schedule',
      },
      testScope: {
        fields: {
          coverageTarget: 'Coverage Target',
          nonFunctionalTarget: 'Non-Functional Target',
          outOfScope: 'Out of Scope',
          perspectives: 'Test Perspectives',
          testArtifact: 'Test Artifacts',
        },
        perspectiveOptions: {
          ACCOUNTABILITY: 'Accountability',
          ADAPTABILITY: 'Adaptability',
          ANALYSABILITY: 'Analysability',
          APPROPRIATENESS_RECOGNIZABILITY: 'Appropriateness Recognizability',
          AUTHENTICITY: 'Authenticity',
          AVAILABILITY: 'Availability',
          CAPACITY: 'Capacity',
          CO_EXISTENCE: 'Co-existence',
          CONFIDENTIALITY: 'Confidentiality',
          FAIL_SAFE: 'Fail Safe',
          FAULT_TOLERANCE: 'Fault Tolerance',
          FAULTLESSNESS: 'Faultlessness',
          FUNCTIONAL_APPROPRIATENESS: 'Functional Appropriateness',
          FUNCTIONAL_COMPLETENESS: 'Functional Completeness',
          FUNCTIONAL_CORRECTNESS: 'Functional Correctness',
          HAZARD_WARNING: 'Hazard Warning',
          INCLUSIVITY: 'Inclusivity',
          INSTALLABILITY: 'Installability',
          INTEGRITY: 'Integrity',
          INTEROPERABILITY: 'Interoperability',
          LEARNABILITY: 'Learnability',
          MODIFIABILITY: 'Modifiability',
          MODULARITY: 'Modularity',
          NON_REPUDIATION: 'Non-repudiation',
          OPERABILITY: 'Operability',
          OPERATIONAL_CONSTRAINT: 'Operational Constraint',
          RECOVERABILITY: 'Recoverability',
          REPLACEABILITY: 'Replaceability',
          RESISTANCE: 'Resistance',
          RESOURCE_UTILIZATION: 'Resource Utilization',
          REUSABILITY: 'Reusability',
          RISK_IDENTIFICATION: 'Risk Identification',
          SAFE_INTEGRATION: 'Safe Integration',
          SCALABILITY: 'Scalability',
          SELF_DESCRIPTIVENESS: 'Self-descriptiveness',
          TESTABILITY: 'Testability',
          TIME_BEHAVIOUR: 'Time Behaviour',
          USER_ASSISTANCE: 'User Assistance',
          USER_ENGAGEMENT: 'User Engagement',
          USER_ERROR_PROTECTION: 'User Error Protection',
        },
        sectionTitle: 'Test Scope',
      },
      testTeam: {
        fields: {
          participantPersonIds: 'Test Team',
          rolesAndResponsibilities: 'Roles & Responsibilities',
          stakeholders: 'Stakeholders',
        },
        participantSearchPlaceholder: 'Search members...',
        sectionTitle: 'Test Team',
      },
    },
    testReview: {
      approval: {
        approvedAt: 'Approved at',
        approvers: 'Approvers',
        auditMeta: 'Approval Date / Related Information',
        relatedTicket: 'Related Ticket',
        title: 'Approval & Responsibility (For Audit)',
      },
      completion: {
        result: 'Review Result',
        reviewedAt: 'Review Completed at',
        reviewer: 'Reviewer',
        targetProduction: 'Target Production',
        testPlan: 'Test Plan',
        title: 'Review Completion Info',
      },
      conditions: {
        releaseCondition: 'Release Conditions',
        remainingRisk: 'Remaining Risks',
        title: 'Conditions & Risks',
      },
      judgement: {
        empty: 'Not entered',
        title: 'QA Review Judgement',
      },
      loading: 'Loading...',
      related: {
        links: {
          closingHistory: 'Closing History (separate screen)',
          openIssues: 'Open Issues',
          previousReview: 'Previous Release Review',
          testResults: 'Test Results (Read Only)',
        },
        title: 'Related Links',
      },
      sidebar: {
        approval: 'Approval',
        completion: 'Completion Info',
        conditions: 'Conditions / Risks',
        judgement: 'Judgement',
        related: 'Related',
        summary: 'Summary',
      },
      summary: {
        defects: {
          title: 'Defects',
        },
        execution: {
          executed: 'Executed',
          notExecuted: 'Not Executed',
          title: 'Test Execution',
        },
        standard: {
          overallJudgement: 'Overall Judgement',
          releaseStandard: 'Release Standard',
          title: 'Quality Standard',
        },
        title: 'Review Summary',
      },
    },
  },
  list: {
    categoryTabs: {
      all: 'All',
      plannedRegular: 'Planned/Regular',
      plannedSpot: 'Planned/Spot',
      unplanned: 'Unplanned',
    },
    emptyValue: '-',
    filterPlaceholder: 'Search test suites...',
    filters: {
      progressStatus: 'Progress Status',
      qualityStatus: 'Quality Status',
    },
    noResults: 'No matching test suites found.',
    pageTitle: 'Test Suites',
    qualityStatus: {
      critical: 'Critical',
      none: 'No Concerns',
      some: 'Has Concerns',
      untouched: 'Untouched',
    },
    status: {
      done: 'Closed',
      paused: 'Paused',
      planning: 'Design',
      running: 'Running',
    },
    table: {
      headers: {
        blockerIssueCount: 'Blocker Count',
        name: 'Name',
        product: 'Product',
        progressStatus: 'Progress Status',
        qualityStatus: 'Quality Status',
        releaseConcernIssueCount: 'Release Concern Issue Count',
        releaseDeadline: 'Release Deadline',
        releaseDecision: 'Release Decision',
        targetVersion: 'Target Version',
        testCompletionDeadline: 'Test Completion Deadline',
        testProgress: 'Test Progress',
      },
    },
    tabs: {
      beforeRelease: 'Before Release',
      overview: 'Overview',
      released: 'Released',
      settings: 'Settings',
    },
  },
  title: 'Test Suites',
};
